import { IFilterByConditionOptions } from './types';

export const getUniqueValuesKey = (allocationId: string) => {
  return `uniqueValues_allocationRecordId_${allocationId || ''}`;
};

export const CONDITION_KEYS = [
  'none',
  'isEqualTo',
  'isLessThan',
  'isGreaterThan',
  'isLessThanOrEqualTo',
  'isGreaterThanOrEqualTo',
  'notEqual',
  'between',
];

export const FILTER_BY_CONDITION_OPTIONS: IFilterByConditionOptions[] = [
  { label: 'Select', value: 'none' },
  { label: 'Is equal to', value: 'isEqualTo' },
  { label: 'Is less than', value: 'isLessThan' },
  { label: 'Is greater than', value: 'isGreaterThan' },
  { label: 'Is less than or equal to', value: 'isLessThanOrEqualTo' },
  { label: 'Is greater than or equal to', value: 'isGreaterThanOrEqualTo' },
  { label: 'Not equal', value: 'notEqual' },
  { label: 'Between', value: 'between' },
];

export const CHANNELS = [
  { label: 'Digital', value: 'Digital' },
  { label: 'Call', value: 'Call' },
  { label: 'Field', value: 'Field' },
];

export const HISTORY = [
  {
    label: 'Unallocated',
    percentage: '10%',
    amount: '14,234',
    lakh: '₹2.4 lakh',
  },
  { label: 'Digital', percentage: '40%', amount: '0', lakh: '₹0' },
  { label: 'Call', percentage: '20%', amount: '0', lakh: '₹0' },
  { label: 'Field', percentage: '30%', amount: '0', lakh: '₹0' },
];

export const ICON_MAPPING: Record<string, string> = {
  field: 'users-01',
  call: 'phone-call-01',
  digital: 'message-text-circle-01',
};

export const ASSIGNED_AGENTS = [
  { label: 'Archit' },
  { label: 'Ramu' },
  { label: 'Veeresh' },
  { label: 'John' },
  { label: 'Tom' },
  { label: 'Henry' },
  { label: 'Archit' },
  { label: 'Ramu' },
  { label: 'Veeresh' },
  { label: 'John' },
  { label: 'Tom' },
  { label: 'Henry' },
];
export const UNASSIGNED_AGENTS = [
  { label: 'Doe' },
  { label: 'Souvik' },
  { label: 'Ashay' },
];
export const CAMPAIGNS = [
  { label: 'Vintage Campaign' },
  { label: 'Special Campaign' },
];

export const SEARCH_PLACEHOLDER = 'Search account number, name or mobile';

export const TUBELIGHT_IFRAME_URL =
  'https://dashboard.hellotubelight.com/sso?agentVerificationKey=agent1@spocto.com&tenant=yubi&hideDashboard=true';

export const DISPOSITION_MODE_OPTIONS = [
  { label: 'NetBanking', value: 'NetBanking' },
  { label: 'Cash', value: 'Cash' },
  { label: 'UPI', value: 'UPI' },
  { label: 'Cheque', value: 'Cheque' },
];

export enum AmplitudeEvents {
  LOGIN_VIEW_EVENT = 'LOGIN_VIEW',
  PAGE_VIEW_EVENT = 'PAGE_VIEW',
  LOGIN_ENTER_PASSWORD_VIEW_EVENT = 'LOGIN_ENTER_PASSWORD_VIEW',
  PASSWORD_FAILED_EVENT = 'PASSWORD_FAILED',
  OTP_SCREEN_VIEW_EVENT = 'OTP_SCREEN_VIEW',
  RESEND_OTP_CLICK_EVENT = 'RESEND_OTP_CLICK',
  VERIFY_OTP_CLICK_EVENT = 'VERIFY_OTP_CLICK',

  NAV_TAB_HOME_CLICK_EVENT = 'NAV_TAB_HOME_CLICK',
  NAV_TAB_DISCOVERY_CLICK_EVENT = 'NAV_TAB_DISCOVERY_CLICK',
  NAV_TAB_CRM_CLICK_EVENT = 'NAV_TAB_CRM_CLICK', // missed in the sheet
  NAV_TAB_COMPLIANCE_CLICK_EVENT = 'NAV_TAB_COMPLIANCE_CLICK',
  NAV_TAB_REPORTS_CLICK_EVENT = 'NAV_TAB_REPORTS_CLICK',
  NAV_TAB_MORE_CLICK_EVENT = 'NAV_TAB_MORE_CLICK',
  NAV_TAB_AUTOCOLLECT_CLICK_EVENT = 'NAV_TAB_AUTOCOLLECT_CLICK',
  NAV_TAB_SCORE_CLICK_EVENT = 'NAV_TAB_SCORE_CLICK',
  NAV_TAB_TRACE_CLICK_EVENT = 'NAV_TAB_TRACE_CLICK',
  NAV_TAB_WORKING_CAPITAL_CLICK_EVENT = 'NAV_TAB_WORKING_CAPITAL_CLICK',
  NAV_TAB_PRICING_CLICK_EVENT = 'NAV_TAB_PRICING_CLICK',
  NAV_TAB_ALLOCATION_CLICK_EVENT = 'NAV_TAB_ALLOCATION_CLICK',
  NAV_TAB_ALLOCATIONLIST_CLICK_EVENT = 'NAV_TAB_ALLOCATIONLIST_CLICK',
  NAV_TAB_AGENTCLICK_EVENT = 'NAV_TAB_AGENTCLICK',
  NAV_TAB_AGENT_LIST_CLICK_EVENT = 'NAV_TAB_AGENT_LIST_CLICK',
  NAV_TAB_AGENT_GROUP_CLICK_EVENT = 'NAV_TAB_AGENT_GROUP_CLICK',

  AGENCIES_PAGE_VIEW_EVENT = 'AGENCIES_PAGE_VIEW',
  DISCOVERY_PAGE_VIEW_EVENT = 'DISCOVERY_PAGE_VIEW',
  DISCOVERY_PAGE_FILTER_CLICK_EVENT = 'DISCOVERY_PAGE_FILTER_CLICK',
  DISCOVERY_PAGE_FILTER_SEARCH_EVENT = 'DISCOVERY_PAGE_FILTER_SEARCH',
  DISCOVERY_PAGE_FILTER_APPLY_CLICK_EVENT = 'DISCOVERY_PAGE_FILTER_APPLY_CLICK',
  DISCOVERY_PAGE_AFTER_FILTER_APPLICATION_EVENT = 'DISCOVERY_PAGE_AFTER_FILTER_APPLICATION',
  DISCOVERY_PAGE_FILTER_RESET_CLICK_EVENT = 'DISCOVERY_PAGE_FILTER_RESET_CLICK',
  DISCOVERY_PAGE_SEARCH_CLICK_EVENT = 'DISCOVERY_PAGE_SEARCH_CLICK',
  DISCOVERY_PAGE_AFTER_SEARCH_APPLICATION_EVENT = 'DISCOVERY_PAGE_AFTER_SEARCH_APPLICATION',
  DISCOVERY_PAGE_EXPRESS_INTEREST_CLICK_EVENT = 'DISCOVERY_PAGE_EXPRESS_INTEREST_CLICK',
  DISCOVERY_PAGE_ALLOCATE_FILE_CLICK_EVENT = 'DISCOVERY_PAGE_ALLOCATE_FILE_CLICK',
  DISCOVERY_PAGE_VIEW_DASHBOARD_CLICK_EVENT = 'DISCOVERY_PAGE_VIEW_DASHBOARD_CLICK',
  DISCOVERY_PAGE_UPLOAD_ALLOCATION_CLICK_EVENT = 'DISCOVERY_PAGE_UPLOAD_ALLOCATION_CLICK',
  DISCOVERY_PAGE_AGENCY_PROFILE_VIEW_EVENT = 'DISCOVERY_PAGE_AGENCY_PROFILE_VIEW',
  DISCOVERY_AGENCY_PROFILE_PAGE_EXPRESS_INTEREST_CLICK_EVENT = 'DISCOVERY_AGENCY_PROFILE_PAGE_EXPRESS_INTEREST_CLICK',
  DISCOVERY_AGENCY_PROFILE_RATING_CLICK_EVENT = 'DISCOVERY_AGENCY_PROFILE_RATING_CLICK',

  CRM_HOME_PAGE_VIEW_EVENT = 'CRM_HOME_PAGE_VIEW',
  CRM_CAMPAIGN_SELECT_CLICK_EVENT = 'CRM_CAMPAIGN_SELECT_CLICK',
  CRM_DISPOSITION_FILTER_CLICK_EVENT = 'CRM_DISPOSITION_FILTER_CLICK',
  CRM_HOME_PAGE_SEARCH_CLICK_EVENT = 'CRM_HOME_PAGE_SEARCH_CLICK',
  CRM_DIALER_CLICK_EVENT = 'CRM_DIALER_CLICK',
  CRM_DIALER_ONLINE_CLICK_EVENT = 'CRM_DIALER_ONLINE_CLICK',
  CRM_NAME_CLICK_EVENT = 'CRM_NAME_CLICK',
  CRM_CALL_BUTTON_CLICK_EVENT = 'CRM_CALL_BUTTON_CLICK',
  CRM_CALL_DISCONNECT_CLICK_EVENT = 'CRM_CALL_DISCONNECT_CLICK',
  CRM_BORROWER_DETAIL_PAGE_VIEW_EVENT = 'CRM_BORROWER_DETAIL_PAGE_VIEW',
  CRM_DISPOSITION_SUBMIT_CLICK_EVENT = 'CRM_DISPOSITION_SUBMIT_CLICK',
  CRM_ACTIVITY_HISTORY_PAGE_VIEW_EVENT = 'CRM_ACTIVITY_HISTORY_PAGE_VIEW',
  CRM_ACTIVITY_HISTORY_SEARCH_CLICK_EVENT = 'CRM_ACTIVITY_HISTORY_SEARCH_CLICK',
  CRM_ACTIVITY_HISTORY_CHANNEL_CLICK_EVENT = 'CRM_ACTIVITY_HISTORY_CHANNEL_CLICK',
  CRM_ACTIVITY_HISTORY_CALENDAR_SET_CLICK_EVENT = 'CRM_ACTIVITY_HISTORY_CALENDAR_SET_CLICK',
  CRM_AGENT_STATUS_CHANGE_EVENT = 'CRM_AGENT_STATUS_CHANGE',

  // CRM Filter Events
  CRM_FILTER_CLICK_EVENT = 'CRM_FILTER_CLICK',
  CRM_FILTER_SORT_CLICK_EVENT = 'CRM_FILTER_SORT_CLICK',
  CRM_FILTER_BY_VALUE_CLICK_EVENT = 'CRM_FILTER_BY_VALUE_CLICK',
  CRM_FILTER_BY_CONDITION_CLICK_EVENT = 'CRM_FILTER_BY_CONDITION_CLICK',
  CRM_FILTER_APPLY_CLICK_EVENT = 'CRM_FILTER_APPLY_CLICK',
  CRM_FILTER_BY_VALUE_SELECT_CLICK_EVENT = 'CRM_FILTER_BY_VALUE_SELECT_CLICK',
  CRM_FILTER_SORT_SELECTED_CLICK_EVENT = 'CRM_FILTER_SORT_SELECTED_CLICK',
  CRM_ACTIVITY_HISTORY_CALENDAR_CLICK_EVENT = 'CRM_ACTIVITY_HISTORY_CALENDAR_CLICK',

  ALLOCATOR_SELECTION_PAGE_VIEW_EVENT = 'ALLOCATOR_SELECTION_PAGE_VIEW',
  ALLOCATOR_SELECT_CLICK_EVENT = 'ALLOCATOR_SELECT_CLICK',
  ALLOCATION_LIST_PAGE_VIEW_EVENT = 'ALLOCATION_LIST_PAGE_VIEW',
  ALLOCATION_LIST_TAB_CLICK_EVENT = 'ALLOCATION_LIST_TAB_CLICK',
  ALLOCATION_LIST_SEARCH_CLICK_EVENT = 'ALLOCATION_LIST_SEARCH_CLICK',
  ALLOCATION_LIST_ALLOCATION_ROW_CLICK_EVENT = 'ALLOCATION_LIST_ALLOCATION_ROW_CLICK',
  ALLOCATION_LIST_UPLOAD_PAYMENT_FILE_CLICK_EVENT = 'ALLOCATION_LIST_UPLOAD_PAYMENT_FILE_CLICK',
  ALLOCATION_LIST_VIEW_PAYMENT_FILE_CLICK_EVENT = 'ALLOCATION_LIST_VIEW_PAYMENT_FILE_CLICK',
  ALLOCATION_LIST_VIEW_ACTION_CLICK_EVENT = 'ALLOCATION_LIST_VIEW_ACTION_CLICK',
  ALLOCATION_LIST_VIEW_ACTION_DASHBOARD_CLICK_EVENT = 'ALLOCATION_LIST_VIEW_ACTION_DASHBOARD_CLICK',
  ALLOCATION_LIST_VIEW_ACTION_DOWNLOAD_CLICK_EVENT = 'ALLOCATION_LIST_VIEW_ACTION_DOWNLOAD_CLICK',
  ALLOCATION_LIST_UPLOAD_ALLOCATION_CLICK_EVENT = 'ALLOCATION_LIST_UPLOAD_ALLOCATION_CLICK',
  ALLOCATION_LIST_DELETE_ALLOCATION_CLICK_EVENT = 'ALLOCATION_LIST_DELETE_ALLOCATION_CLICK',
  ALLOCATION_LIST_FILTER_CLICK_EVENT = 'ALLOCATION_LIST_FILTER_CLICK',
  ALLOCATION_LIST_FILTER_SORT_CLICK_EVENT = 'ALLOCATION_LIST_FILTER_SORT_CLICK',
  ALLOCATION_LIST_FILTER_BY_VALUE_CLICK_EVENT = 'ALLOCATION_LIST_FILTER_BY_VALUE_CLICK',
  ALLOCATION_LIST_FILTER_BY_CONDITION_CLICK_EVENT = 'ALLOCATION_LIST_FILTER_BY_CONDITION_CLICK',
  ALLOCATION_LIST_FILTER_APPLY_CLICK_EVENT = 'ALLOCATION_LIST_FILTER_APPLY_CLICK',
  ALLOCATION_LIST_FILTER_BY_VALUE_SELECT_CLICK_EVENT = 'ALLOCATION_LIST_FILTER_BY_VALUE_SELECT_CLICK',
  ALLOCATION_LIST_FILTER_SORT_SELECTED_CLICK_EVENT = 'ALLOCATION_LIST_FILTER_SORT_SELECTED_CLICK',

  UPLOAD_ALLOCATION_PAGE_VIEW_EVENT = 'UPLOAD_ALLOCATION_PAGE_VIEW',
  UPLOAD_ALLOCATION_BROWSE_CLICK_EVENT = 'UPLOAD_ALLOCATION_BROWSE_CLICK',
  UPLOAD_ALLOCATION_PAGE_PRODUCT_CLICK_EVENT = 'UPLOAD_ALLOCATION_PAGE_PRODUCT_CLICK',
  UPLOAD_ALLOCATION_PAGE_PRODUCT_SELECTED_EVENT = 'UPLOAD_ALLOCATION_PAGE_PRODUCT_SELECTED',
  UPLOAD_ALLOCATION_PAGE_BUCKET_CLICK_EVENT = 'UPLOAD_ALLOCATION_PAGE_BUCKET_CLICK',
  UPLOAD_ALLOCATION_PAGE_BUCKET_SELECTED_EVENT = 'UPLOAD_ALLOCATION_PAGE_BUCKET_SELECTED',
  UPLOAD_ALLOCATION_PAGE_START_DATE_CLICK_EVENT = 'UPLOAD_ALLOCATION_PAGE_START_DATE_CLICK',
  UPLOAD_ALLOCATION_PAGE_START_DATE_SELECTED_EVENT = 'UPLOAD_ALLOCATION_PAGE_START_DATE_SELECTED',
  UPLOAD_ALLOCATION_PAGE_END_DATE_SELECTED_EVENT = 'UPLOAD_ALLOCATION_PAGE_END_DATE_SELECTED',
  UPLOAD_ALLOCATION_PAGE_CALENDAR_SET_SELECTED_EVENT = 'UPLOAD_ALLOCATION_PAGE_CALENDAR_SET_SELECTED',
  UPLOAD_ALLOCATION_PAGE_CALENDAR_CANCEL_SELECTED_EVENT = 'UPLOAD_ALLOCATION_PAGE_CALENDAR_CANCEL_SELECTED',
  UPLOAD_ALLOCATION_PROCEED_CLICK_EVENT = 'UPLOAD_ALLOCATION_PROCEED_CLICK',
  UPLOAD_ALLOCATION_CANCEL_CLICK_EVENT = 'UPLOAD_ALLOCATION_CANCEL_CLICK',

  CHANNEL_PLANNER_PAGE_VIEW_EVENT = 'CHANNEL_PLANNER_PAGE_VIEW',
  CHANNEL_PLANNER_PAGE_BACK_CLICK_EVENT = 'CHANNEL_PLANNER_PAGE_BACK_CLICK',
  CHANNEL_PLANNER_MERGE_HISTORIC_DATA_CLICK_EVENT = 'CHANNEL_PLANNER_MERGE_HISTORIC_DATA_CLICK',
  CHANNEL_PLANNER_DOWNLOAD_HISTORIC_DATA_CLICK_EVENT = 'CHANNEL_PLANNER_DOWNLOAD_HISTORIC_DATA_CLICK',
  CHANNEL_PLANNER_SEARCH_CLICK_EVENT = 'CHANNEL_PLANNER_SEARCH_CLICK',
  CHANNEL_PLANNER_FILTER_CLICK_EVENT = 'CHANNEL_PLANNER_FILTER_CLICK',
  CHANNEL_PLANNER_FILTER_SORT_CLICK_EVENT = 'CHANNEL_PLANNER_FILTER_SORT_CLICK',
  CHANNEL_PLANNER_FILTER_SORT_SELECTED_CLICK_EVENT = 'CHANNEL_PLANNER_FILTER_SORT_SELECTED_CLICK',
  CHANNEL_PLANNER_FILTER_BY_VALUE_CLICK_EVENT = 'CHANNEL_PLANNER_FILTER_BY_VALUE_CLICK',
  CHANNEL_PLANNER_FILTER_BY_VALUE_SELECT_CLICK_EVENT = 'CHANNEL_PLANNER_FILTER_BY_VALUE_SELECT_CLICK',
  CHANNEL_PLANNER_FILTER_BY_CONDITION_CLICK_EVENT = 'CHANNEL_PLANNER_FILTER_BY_CONDITION_CLICK',
  CHANNEL_PLANNER_FILTER_APPLY_CLICK_EVENT = 'CHANNEL_PLANNER_FILTER_APPLY_CLICK',
  CHANNEL_PLANNER_SELECT_ALL_CLICK_EVENT = 'CHANNEL_PLANNER_SELECT_ALL_CLICK',
  CHANNEL_PLANNER_SELECT_CLICK_EVENT = 'CHANNEL_PLANNER_SELECT_CLICK',
  CHANNEL_PLANNER_PAGINATION_CHANGE_EVENT = 'CHANNEL_PLANNER_PAGINATION_CHANGE_EVENT',
  // CHANNEL_PLANNER_PAGINATION_SELECT_CLICK_EVENT = 'CHANNEL_PLANNER_PAGINATION_SELECT_CLICK',
  // CHANNEL_PLANNER_PAGINATION_NEXT_CLICK_EVENT = 'CHANNEL_PLANNER_PAGINATION_NEXT_CLICK',
  // CHANNEL_PLANNER_PAGINATION_PREVIOUS_CLICK_EVENT = 'CHANNEL_PLANNER_PAGINATION_PREVIOUS_CLICK',
  CHANNEL_PLANNER_ASSIGN_CHANNEL_CLICK_EVENT = 'CHANNEL_PLANNER_ASSIGN_CHANNEL_CLICK',
  CHANNEL_PLANNER_ASSIGN_CHANNEL_SELECT_CLICK_EVENT = 'CHANNEL_PLANNER_ASSIGN_CHANNEL_SELECT_CLICK',
  CHANNEL_PLANNER_ASSIGN_CHANNEL_SUCCESS_EVENT = 'CHANNEL_PLANNER_ASSIGN_CHANNEL_SUCCESS_EVENT',
  // CHANNEL_PLANNER_PROCEED_CLICK_EVENT = 'CHANNEL_PLANNER_PROCEED_CLICK',

  CHANNEL_ALLOCATION_SUMMARY_PAGE_VIEW_EVENT = 'CHANNEL_ALLOCATION_SUMMARY_PAGE_VIEW',
  CHANNEL_ALLOCATION_SUMMARY_BACK_CLICK_EVENT = 'CHANNEL_ALLOCATION_SUMMARY_BACK_CLICK',
  CHANNEL_ALLOCATION_SUMMARY_DIGITAL_CLICK_EVENT = 'CHANNEL_ALLOCATION_SUMMARY_DIGITAL_CLICK',
  CHANNEL_ALLOCATION_SUMMARY_CALL_CLICK_EVENT = 'CHANNEL_ALLOCATION_SUMMARY_CALL_CLICK',
  CHANNEL_ALLOCATION_SUMMARY_FIELD_CLICK_EVENT = 'CHANNEL_ALLOCATION_SUMMARY_FIELD_CLICK',

  DIGITAL_ALLOCATION_SUMMARY_PAGE_VIEW_EVENT = 'DIGITAL_ALLOCATION_SUMMARY_PAGE_VIEW',
  DIGITAL_ALLOCATION_SUMMARY_PAGE_START_CLICK_EVENT = 'DIGITAL_ALLOCATION_SUMMARY_PAGE_START_CLICK',
  DIGITAL_ALLOCATION_SUMMARY_PAGE_STOP_CLICK_EVENT = 'DIGITAL_ALLOCATION_SUMMARY_PAGE_STOP_CLICK',

  DIGITAL_PLANNERY_PAGE_VIEW_EVENT = 'DIGITAL_PLANNERY_PAGE_VIEW',
  DIGITAL_PLANNERY_PAGE_BACK_CLICK_EVENT = 'DIGITAL_PLANNERY_PAGE_BACK_CLICK',
  DIGITAL_PLANNERY_ASSIGN_CAMPAIGN_CLICK_EVENT = 'DIGITAL_PLANNERY_ASSIGN_CAMPAIGN_CLICK',

  CALL_ALLOCATION_SUMMARY_PAGE_VIEW_EVENT = 'CALL_ALLOCATION_SUMMARY_PAGE_VIEW',
  CALL_PLANNER_PAGE_BACK_CLICK_EVENT = 'CALL_PLANNER_PAGE_BACK_CLICK',
  CALL_PLANNER_PAGE_SELECT_ALL_CLICK_EVENT = 'CALL_PLANNER_PAGE_SELECT_ALL_CLICK',
  CALL_SUMMARY_PAGE_BACK_CLICK_EVENT = 'CALL_SUMMARY_PAGE_BACK_CLICK',
  CALL_SUMMARY_SEARCH_CLICK_EVENT = 'CALL_SUMMARY_SEARCH_CLICK',
  CALL_SUMMARY_FILTER_CLICK_EVENT = 'CALL_SUMMARY_FILTER_CLICK',
  CALL_SUMMARY_FILTER_SORT_CLICK_EVENT = 'CALL_SUMMARY_FILTER_SORT_CLICK',
  CALL_SUMMARY_FILTER_SORT_SELECTED_CLICK_EVENT = 'CALL_SUMMARY_FILTER_SORT_SELECTED_CLICK',
  CALL_SUMMARY_FILTER_BY_VALUE_CLICK_EVENT = 'CALL_SUMMARY_FILTER_BY_VALUE_CLICK',
  CALL_SUMMARY_FILTER_BY_VALUE_SELECT_CLICK_EVENT = 'CALL_SUMMARY_FILTER_BY_VALUE_SELECT_CLICK',
  CALL_SUMMARY_FILTER_BY_CONDITION_CLICK_EVENT = 'CALL_SUMMARY_FILTER_BY_CONDITION_CLICK',
  CALL_SUMMARY_FILTER_APPLY_CLICK_EVENT = 'CALL_SUMMARY_FILTER_APPLY_CLICK',
  CALL_SUMMARY_SELECT_ALL_CLICK_EVENT = 'CALL_SUMMARY_SELECT_ALL_CLICK',
  CALL_SUMMARY_SELECT_CLICK_EVENT = 'CALL_SUMMARY_SELECT_CLICK',
  CALL_SUMMARY_PAGINATION_CHANGE_EVENT = 'CALL_SUMMARY_PAGINATION_CHANGE',
  // CALL_SUMMARY_PAGINATION_CLICK_EVENT = 'CALL_SUMMARY_PAGINATION_CLICK',
  // CALL_SUMMARY_PAGINATION_SELECT_CLICK_EVENT = 'CALL_SUMMARY_PAGINATION_SELECT_CLICK',
  // CALL_SUMMARY_PAGINATION_NEXT_CLICK_EVENT = 'CALL_SUMMARY_PAGINATION_NEXT_CLICK',
  // CALL_SUMMARY_PAGINATION_PREVIOUS_CLICK_EVENT = 'CALL_SUMMARY_PAGINATION_PREVIOUS_CLICK',
  // CALL_SUMMARY_ASSIGN_CAMPAIGN_CLICK_EVENT = 'CALL_SUMMARY_ASSIGN_CAMPAIGN_CLICK',
  // CALL_SUMMARY_ASSIGN_CAMPAIGN_AGENT_SELECT_EVENT = 'CALL_SUMMARY_ASSIGN_CAMPAIGN_AGENT_SELECT',
  // CALL_SUMMARY_ASSIGN_CAMPAIGN_AGENT_UNSELECT_EVENT = 'CALL_SUMMARY_ASSIGN_CAMPAIGN_AGENT_UNSELECT',
  CALL_PLANNER_ASSIGN_CAMPAIGN_SELECT_CLICK_EVENT = 'CALL_SUMMARY_ASSIGN_CAMPAIGN_SELECT_CLICK',
  CALL_SUMMARY_PROCEED_CLICK_EVENT = 'CALL_SUMMARY_PROCEED_CLICK',

  CALL_CENTER_ALLOCATION_SUMMARY_PAGE_VIEW_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_PAGE_VIEW',
  CALL_CENTER_TAB_CLICK_EVENT = 'CALL_CENTER_TAB_CLICK',
  CALL_CENTER_GROUP_FILTER_CLICK_EVENT = 'CALL_CENTER_GROUP_FILTER_CLICK',
  CALL_CENTER_GROUP_FILTER_SELECT_CLICK_EVENT = 'CALL_CENTER_GROUP_FILTER_SELECT_CLICK',
  CALL_PLANNER_CAMPAIGN_CLICK_EVENT = 'CALL_PLANNER_CAMPAIGN_CLICK',
  CALL_CENTER_ALLOCATION_SUMMARY_SEARCH_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_SEARCH_CLICK',
  CALL_CENTER_ALLOCATION_SUMMARY_FILTER_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_FILTER_CLICK',
  CALL_CENTER_ALLOCATION_SUMMARY_FILTER_SORT_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_FILTER_SORT_CLICK',
  CALL_CENTER_ALLOCATION_SUMMARY_FILTER_SORT_SELECTED_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_FILTER_SORT_SELECTED_CLICK',
  CALL_CENTER_ALLOCATION_SUMMARY_FILTER_BY_VALUE_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_FILTER_BY_VALUE_CLICK',
  CALL_CENTER_ALLOCATION_SUMMARY_FILTER_BY_VALUE_SELECT_VALUE_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_FILTER_BY_VALUE_SELECT_VALUE_CLICK',
  CALL_CENTER_ALLOCATION_SUMMARY_FILTER_BY_CONDITION_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_FILTER_BY_CONDITION_CLICK',
  CALL_CENTER_ALLOCATION_SUMMARY_FILTER_BY_CONDITION_SELECT_VALUE_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_FILTER_BY_CONDITION_SELECT_VALUE_CLICK',
  CALL_CENTER_ALLOCATION_SUMMARY_FILTER_APPLY_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_FILTER_APPLY_CLICK',
  CALL_CENTER_ALLOCATION_SUMMARY_PAGINATION_CHANGE_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_PAGINATION_CHANGE',
  // CALL_CENTER_ALLOCATION_SUMMARY_PAGINATION_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_PAGINATION_CLICK',
  // CALL_CENTER_ALLOCATION_SUMMARY_PAGINATION_SELECT_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_PAGINATION_SELECT_CLICK',
  // CALL_CENTER_ALLOCATION_SUMMARY_PAGINATION_NEXT_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_PAGINATION_NEXT_CLICK',
  // CALL_CENTER_ALLOCATION_SUMMARY_PAGINATION_PREVIOUS_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_PAGINATION_PREVIOUS_CLICK',
  CALL_CENTER_ALLOCATION_SUMMARY_REASSIGN_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_REASSIGN_CLICK',
  CALL_CENTER_ALLOCATION_SUMMARY_REASSIGN_PROCEED_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_REASSIGN_PROCEED_CLICK',
  CALL_CENTER_ALLOCATION_SUMMARY_UNASSIGN_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_UNASSIGN_CLICK',
  CALL_CENTER_ALLOCATION_SUMMARY_UNASSIGN_PROCEED_CLICK_EVENT = 'CALL_CENTER_ALLOCATION_SUMMARY_UNASSIGN_PROCEED_CLICK',

  FIELD_AGENT_ASSIGNMENT_PAGE_VIEW_EVENT = 'FIELD_AGENT_ASSIGNMENT_PAGE_VIEW',
  FIELD_AGENT_ASSIGNMENT_PAGE_BACK_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_PAGE_BACK_CLICK',
  FIELD_AGENT_ASSIGNMENT_TAB_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_TAB_CLICK',
  FIELD_AGENT_ASSIGNMENT_SELECT_ALL_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_SELECT_ALL_CLICK',
  FIELD_AGENT_ASSIGNMENT_SELECT_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_SELECT_CLICK',
  FIELD_AGENT_ASSIGNMENT_PAGINATION_CHANGE_EVENT = 'FIELD_AGENT_ASSIGNMENT_PAGINATION_CHANGE_EVENT',
  // FIELD_AGENT_ASSIGNMENT_PAGINATION_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_PAGINATION_CLICK',
  // FIELD_AGENT_ASSIGNMENT_PAGINATION_SELECT_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_PAGINATION_SELECT_CLICK',
  // FIELD_AGENT_ASSIGNMENT_PAGINATION_NEXT_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_PAGINATION_NEXT_CLICK',
  // FIELD_AGENT_ASSIGNMENT_PAGINATION_PREVIOUS_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_PAGINATION_PREVIOUS_CLICK',
  FIELD_AGENT_ASSIGNMENT_SEARCH_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_SEARCH_CLICK',
  FIELD_AGENT_ASSIGNMENT_ASSIGN_AGENT_EVENT = 'FIELD_AGENT_ASSIGNMENT_ASSIGN_AGENT',
  FIELD_AGENT_ASSIGNMENT_FILTER_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_FILTER_CLICK',
  FIELD_AGENT_ASSIGNMENT_FILTER_SORT_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_FILTER_SORT_CLICK',
  FIELD_AGENT_ASSIGNMENT_FILTER_SORT_SELECTED_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_FILTER_SORT_SELECTED_CLICK',
  FIELD_AGENT_ASSIGNMENT_FILTER_BY_VALUE_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_FILTER_BY_VALUE_CLICK',
  FIELD_AGENT_ASSIGNMENT_FILTER_BY_VALUE_SELECT_VALUE_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_FILTER_BY_VALUE_SELECT_VALUE_CLICK',
  FIELD_AGENT_ASSIGNMENT_FILTER_BY_CONDITION_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_FILTER_BY_CONDITION_CLICK',
  FIELD_AGENT_ASSIGNMENT_FILTER_BY_CONDITION_SELECT_VALUE_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_FILTER_BY_CONDITION_SELECT_VALUE_CLICK',
  FIELD_AGENT_ASSIGNMENT_FILTER_APPLY_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_FILTER_APPLY_CLICK',
  FIELD_AGENT_ASSIGNMENT_CHOOSE_AGENT_APPLY_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_CHOOSE_AGENT_APPLY_CLICK',
  FIELD_AGENT_ASSIGNMENT_REASSIGN_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_REASSIGN_CLICK',
  FIELD_AGENT_ASSIGNMENT_UNASSIGN_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_UNASSIGN_CLICK',
  FIELD_AGENT_ASSIGNMENT_SCHEDULE_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_SCHEDULE_CLICK',
  FIELD_AGENT_ASSIGNMENT_SCHEDULE_CONFIRM_CLICK_EVENT = 'FIELD_AGENT_ASSIGNMENT_SCHEDULE_CONFIRM_CLICK',

  CAMPAIGN_ALLOCATION_SUMMARY_PAGE_BACK_CLICK_EVENT = 'CAMPAIGN_ALLOCATION_SUMMARY_PAGE_BACK_CLICK_EVENT',
  FIELD_AGENT_ASSIGNMENT_AUTO_ASSIGN_AGENT_EVENT = 'FIELD_AGENT_ASSIGNMENT_AUTO_ASSIGN_AGENT',

  DASHBOARD_ALLOCATION_CARD_CLICK_EVENT = 'DASHBOARD_ALLOCATION_CARD_CLICK',
  DASHBOARD_PAGE_VIEW_EVENT = 'DASHBOARD_PAGE_VIEW',
  DASHBOARD_PAGE_BACK_CLICK_EVENT = 'DASHBOARD_PAGE_BACK_CLICK',
  DASHBOARD_PAGE_TAB_CLICK_EVENT = 'DASHBOARD_PAGE_TAB_CLICK',
  DASHBOARD_CALL_LIVE_MONITORING_CLICK_EVENT = 'DASHBOARD_CALL_LIVE_MONITORING_CLICK',
  DASHBOARD_CALL_AGENT_PERFORMANCE_CLICK_EVENT = 'DASHBOARD_CALL_AGENT_PERFORMANCE_CLICK',
  DASHBOARD_CALL_DISPOSITION_HOVER_EVENT = 'DASHBOARD_CALL_DISPOSITION_HOVER',
  DASHBOARD_CALL_SEARCH_AGENT_EVENT = 'DASHBOARD_CALL_SEARCH_AGENT',
  DASHBOARD_FIELD_LIVE_MONITORING_CLICK_EVENT = 'DASHBOARD_FIELD_LIVE_MONITORING_CLICK',
  DASHBOARD_FIELD_DEVIATION_MONITORING_CLICK_EVENT = 'DASHBOARD_FIELD_DEVIATION_MONITORING_CLICK',
  DASHBOARD_FIELD_VISIT_SUMMARY_CLICK_EVENT = 'DASHBOARD_FIELD_VISIT_SUMMARY_CLICK',
  DASHBOARD_DIGITAL_ENGAGEMENTBYACCOUNT_HOVER_EVENT = 'DASHBOARD_DIGITAL_ENGAGEMENTBYACCOUNT_HOVER',
  DASHBOARD_DIGITAL_ENGAGEMENTBYOUTSTANDING_HOVER_EVENT = 'DASHBOARD_DIGITAL_ENGAGEMENTBYOUTSTANDING_HOVER',
  // DASHBOARD_FDIGITAL_CALENDER_SET_EVENT = 'DASHBOARD_FDIGITAL_CALENDER_SET',
  // DASHBOARD_FDIGITAL_CALENDER_CANCEL_EVENT = 'DASHBOARD_FDIGITAL_CALENDER_CANCEL',
  DASHBOARD_DIGITAL_CALENDER_START_DATE_SELECTED_EVENT = 'DASHBOARD_DIGITAL_CALENDER_START_DATE_SELECTED',
  DASHBOARD_DIGITAL_CALENDER_END_DATE_SELECTED_EVENT = 'DASHBOARD_DIGITAL_CALENDER_END_DATE_SELECTED',
  PROFILE_CLICK_EVENT = 'PROFILE_CLICK',
  PROFILE_SETTING_CLICK_EVENT = 'PROFILE_SETTING_CLICK',
  PROFILE_LOGOUT_CLICK_EVENT = 'PROFILE_LOGOUT_CLICK',
  AGENCY_DISCOVERY_CLICK_EVENT = 'AGENCY_DISCOVERY_CLICK_EVENT',
  ALLOCATION_LIST_UPLOAD_UNSUBSCRIBE_FILE_CLICK_EVENT = 'ALLOCATION_LIST_UPLOAD_UNSUBSCRIBE_FILE_CLICK_EVENT',
  EDIT_OPS_COLUMN_MAPPING_CLICK_EVENT = 'EDIT_OPS_COLUMN_MAPPING_CLICK_EVENT',
  CANCEL_OPS_COLUMN_MAPPING_CLICK_EVENT = 'CANCEL_OPS_COLUMN_MAPPING_CLICK_EVENT',

  // Company Registration Events
  COMPANY_REGISTRATION_PAGE_VIEW = 'Company_Registration_page_view',
  COMPANY_REGISTRATION_STEP1_CONTINUE_CLICK = 'Company_Registration_step1_continue_click',
  COMPANY_REGISTRATION_ASSOCIATED_COMPANY_FIELD_CLICK = 'Company_Registration_Associated_company_field_click',
  COMPANY_REGISTRATION_YOUR_NAME_FIELD_CLICK = 'Company_Registration_Your_name_field_click',
  COMPANY_REGISTRATION_YOUR_EMAIL_FIELD_CLICK = 'Company_Registration_Your_email_field_click',
  COMPANY_REGISTRATION_REGISTER_CLICK = 'Company_Registration_register_click',
}

export const EMAIL_NOT_FOUND = 'EMAIL_NOT_FOUND';
export const CAMPAIGN_NAME_NOT_FOUND = 'CAMPAIGN_NAME_NOT_FOUND';

export const MONTHS = [
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER',
];

export const DAYS = Array.from({ length: 31 }, (_, i) => i + 1);

export const YEARS = Array.from(
  { length: 21 },
  (_, i) => new Date().getFullYear() - 10 + i
);

// Common tooltip text
export const ON_GOING_CALL_TEXT = 'Ongoing call...';
export const ON_GOING_CALL_SUB_TEXT =
  'You are already on call with this user, you will be able to move away from this page only after the call closed and disposition done.';

export const acrValues = [
  { label: '0-50', value: '0-50' },
  { label: '50-100', value: '50-100' },
  { label: '100-200', value: '100-200' },
  { label: '200-300', value: '200-300' },
  { label: '300-400', value: '300-400' },
  { label: '400-500', value: '400-500' },
  { label: '500-600', value: '500-600' },
  { label: '600-700', value: '600-700' },
  { label: '700-800', value: '700-800' },
  { label: '800-900', value: '800-900' },
  { label: '900-1000', value: '900-1000' },
];
